export default {
    "_more":"更多",
    
    "add": "新增",
    "confirm": "确认",
    "detail": "详情",
    "search": "查询",
    "clear": "清空",
    "empty": "清空",
    "export": "导出",
    "import": "导入",
    "template": "导入模板下载",
    "save": "保存",
    "cancel": "取消",
    "update": "修改",
    "delete": "删除",
    "pbmsubmit": "提交",
    "pbmcancle": "撤回",
    "pbmapprove": "审批",
    "appoint": "指派",
    "send": "发送",
    "printpreview": "打印预览",
    "printdesign": "打印设计",
    "upload": "上传",
    "reupload": "重新上传",
    "download": "下载",
    "addRow": "增行",
    "delRow": "删行",
    "copyRow": "复制行",
    "max": "最大化",
    "min": "min",
    "copyToEnd": "粘贴至末行",
    "copyToHere": "粘贴至此处",
    "organizationChat": "机构图",
    "enable": "启用",
    "disabled": "停用",
    "next": "下一条",
    "previous": "上一条",
    "first": "第一条",
    "last": "最后一条"
}


// WEBPACK FOOTER //
// ./src/locale/zh_CN.js